import React from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AppShell({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <div className="grid min-h-screen grid-rows-[auto_1fr]">
      <Topbar />
      <div className="grid grid-cols-1 md:grid-cols-[16rem_1fr]">
        <Sidebar />
        <main className="p-4">{children}</main>
      </div>
    </div>
  );
}
